import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import CircularProgress from '@material-ui/core/CircularProgress';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import { fetchHeadersOfSessionFile } from '../../../../api';

const styles = () => ({
  list: {
    display: 'inline-block',
    minWidth: '260px',
    margin: '10px',
    boxShadow: '0px 0px 5px 0px #d0d0d0',
    height: '400px',
    overflowX: 'auto',
  },
  ul: {
    padding: '0px',
  },
  loading: {
    margin: '80px',
    textAlign: 'center',
  },
  li: {
    padding: '0px',
    cursor: 'pointer',
  },
  title: {
    marginLeft: '10px',
  },
  button: {
    float: 'right',
    marginRight: '10px',
  },
});

class SelectJoinColumnList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      headers: [],
      toggleAll: false,
      isLoading: true,
    };

    this.handleChange = this.handleChange.bind(this);
    this.toggleAll = this.toggleAll.bind(this);
  }

  async componentDidMount() {
    const { file, sessionId, lockedHeaders } = this.props;
    if (file.id) {
      const headers = await fetchHeadersOfSessionFile(sessionId, file.id);
      const headersWithData = headers.map(header => {
        return {
          name: header,
          nameWithFileName: `${file.filename}.${header}`,
          checked: true,
          locked: lockedHeaders.includes(header),
        }
      });

      this.setState({ headers: headersWithData, isLoading: false });
      this.props.onChange(headersWithData, file.id);
    }
  }

  handleChange(rowindex) {
    const { file } = this.props;
    const { headers } = this.state;

    const newHeaders = headers.map((header, index) => {
      if (index === rowindex && !header.locked) {
        return {
          name: header.name,
          nameWithFileName: header.nameWithFileName,
          checked: !header.checked,
          locked: header.locked,
        }
      }
      return header;
    });

    this.props.onChange(newHeaders, file.id);
    this.setState({ headers: newHeaders })
  }

  toggleAll() {
    const { headers, toggleAll } = this.state;
    const newHeaders = headers.map(header => {
      if (!header.locked) {
        return {
          name: header.name,
          nameWithFileName: header.nameWithFileName,
          checked: toggleAll,
          locked: header.locked,
        }
      }
      return header;
    });

    this.setState({ headers: newHeaders, toggleAll: !toggleAll })
    this.props.onChange(newHeaders, this.props.file.id);
  }

  render() {
    const { file, classes } = this.props;

    return (
      <React.Fragment>
        <Typography className={classes.title} variant="button" gutterBottom>
          {file.filename}
          <Button variant="contained" color="primary" size="small" className={classes.button} onClick={this.toggleAll}>
            {this.state.toggleAll ? 'Check all' : 'Uncheck all'}
          </Button>
        </Typography>
        <div className={classes.list}>
          <List className={classes.root} subheader={<li />}>
            <ul className={classes.ul}>
              {this.renderListitems()}
            </ul>
          </List>
        </div>
      </React.Fragment>
    );
  }

  renderListitems() {
    const { classes } = this.props;
    const { headers } = this.state;

    if (this.state.isLoading) {
      return <CircularProgress className={classes.loading} size={50} color="secondary" />
    }

    return headers.map((header, index) => {
      return (
        <ListItem className={classes.li} key={index} onClick={() => this.handleChange(index)}>
          <Checkbox
            checked={header.checked}
            tabIndex={-1}
            disableRipple
            disabled={header.locked}
          />
          <ListItemText primary={header.name} />
        </ListItem>
      )
    })
  }
};

SelectJoinColumnList.propTypes = {
  /* eslint-disable react/forbid-prop-types */
  index: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  sessionId: PropTypes.string.isRequired,
  file: PropTypes.shape({
    id: PropTypes.string,
    filename: PropTypes.string,
    lastModified: PropTypes.number,
    savedByUser: PropTypes.bool,
  }),
  lockedHeaders: PropTypes.array.isRequired,
  /* eslint-enable */
};

export default withStyles(styles)(SelectJoinColumnList);
